export const tg = window.Telegram?.WebApp ?? null;

let telegramContext = null;

export function initTelegramApp() {
  if (telegramContext) return telegramContext;

  if (!tg) {
    telegramContext = { isTelegram: false, user: null, initData: '' };
    return telegramContext;
  }

  tg.ready();
  tg.expand();
  tg.enableClosingConfirmation?.();

  const root = document.documentElement;
  const theme = tg.themeParams || {};
  if (theme.button_color) root.style.setProperty('--primary', theme.button_color);
  if (theme.bg_color) root.style.setProperty('--bg', theme.bg_color);

  telegramContext = {
    isTelegram: true,
    user: tg.initDataUnsafe?.user ?? null,
    initData: tg.initData || ''
  };
  return telegramContext;
}

export function getTelegramContext() {
  return telegramContext || initTelegramApp();
}

export function authHeaders() {
  const ctx = getTelegramContext();
  const headers = {};
  if (ctx.initData) headers['X-Telegram-Init-Data'] = ctx.initData;
  if (ctx.user) headers['X-Telegram-User'] = JSON.stringify(ctx.user);
  return headers;
}

export function sendToBot(type, payload = {}) {
  const data = { type, ...payload, ts: Date.now() };
  const serialized = JSON.stringify(data);

  if (tg?.sendData) {
    tg.HapticFeedback?.impactOccurred?.('light');
    tg.sendData(serialized);
    return { ok: true, sentToTelegram: true, payload: data };
  }

  console.info('[Careeva MiniApp fallback payload]', data);
  return { ok: true, sentToTelegram: false, payload: data };
}
